import React, { Component, useRef } from 'react';
import '../StoreSelector.css';
import './NewStoreSelector.css';
import './CurrentStoreMenuItemGrid.css';
import { setCursorStyle } from '../../../../utils/MouseUtilities.js';
import 'semantic-ui-css/components/segment.min.css';
import 'semantic-ui-css/components/image.min.css';

const hoverCursorStyle = 'pointer';
const unhoverCursorStyle = 'all-scroll';

import { StoreSelectorOption, QuizStoreSelectorClick, LegendStoreSelectorClick } from '../../../../utils/Analytics.js';
import { getAllSceneInfoDictAsync } from '../../../../utils/StoreConfigManager';
import { AppContext } from '../../../../AppContext.jsx';
import { ThreeJSWorldContext } from 'web-store-modules/packages/web-store-three-world';
import { getCurrentScene } from '../../../../utils/History';
import CurrentStoreMenuGridItem from './CurrentStoreMenuGridItem';
import { withTranslation } from 'react-i18next';
import I18NextContext from '../../i18next-context/I18NextContext';


const menuLine = "https://cdn.obsess-vr.com/ferragamo/menu/line-1.png";
const giftImg = "https://cdn.obsess-vr.com/ferragamo/menu/gift-box-1.png";
const mapImg = "https://cdn.obsess-vr.com/ferragamo/map-of-house.svg";
const legendImg = "https://cdn.obsess-vr.com/ferragamo/information.svg";
const arrowUnexpanded = "https://cdn.obsess-vr.com/ferragamo/arrow-right.png"
const arrowExpanded = "https://cdn.obsess-vr.com/ferragamo/arrow-down.png"

const linkedRandomScenes = (props) => {
    return [
        {
            name: props.t('sectionMenuScene3'),
            scene_id: '614a6a668135ae99e7eb653e',
            img: 'https://cdn.obsess-vr.com/ferragamo/menu/Library_room_v3.png',
            url: '/library'
        },
        {
            name: props.t('sectionMenuScene2'),
            scene_id: '614a6aa5d7bb008cbec58ca9',
            img: 'https://cdn.obsess-vr.com/ferragamo/menu/Piano_room_v3.png',
            url: '/piano'
        },
        {
            name: props.t('sectionMenuScene4'),
            scene_id: '614b3e16d7bb008cbec58cb6',
            img: 'https://cdn.obsess-vr.com/ferragamo/menu/Dining_room_v3.png',
            url: '/dining'
        },
        {
            name: props.t('sectionMenuScene5'),
            scene_id: '614c8c355d0a6b36fe5ab366',
            img: 'https://cdn.obsess-vr.com/ferragamo/menu/Projection_room_v3.png',
            url: '/projection'
        },

    ]
}
class CurrentStoreMenuItemGrid extends Component {
    constructor(props) {
        super(props);
        this.onHover = this.onHover.bind(this);
        this.onUnhover = this.onUnhover.bind(this);
        this.onClick = this.onClick.bind(this);
        this.state =  {
            mapOpen: false
        }
    }

    getCurrentSceneId = () => {
        const { sceneIdNameDict, setCurrentScene } = this.props;
        const scene = getCurrentScene();
        if (sceneIdNameDict) {
            Object.keys(sceneIdNameDict).forEach((key) => {
                if (scene === sceneIdNameDict[key]) {
                    setCurrentScene(key)
                    this.setState({ selectedScene: key });
                }
            })
        }
    }

    onHover() {
        setCursorStyle(hoverCursorStyle);
    }

    onUnhover() {
        setCursorStyle(unhoverCursorStyle);
    }

    onClick(sceneId) {
        const { threeJSWorldContext, setLoadingIconVisibility, closeMenu, setQuizVisibility } = this.props;
        setQuizVisibility(false);
        console.log("SCENE");
        setLoadingIconVisibility(true);
        closeMenu();
        getAllSceneInfoDictAsync()
            .then(sceneInfoDict => {
                if (!sceneInfoDict[sceneId]) {
                    throw new Error('Scene with id ' + sceneId + ' do not exist!');
                }

                const linkedSceneName = sceneInfoDict[sceneId]['name'];
                let targetPath = `/${this.props.currentLanguage}/${linkedSceneName}`;
                StoreSelectorOption(linkedSceneName);

                if (threeJSWorldContext.history.location.pathname !== targetPath) {
                    threeJSWorldContext.pushHistoryWithReset(targetPath)
                } else {
                    this.props.setLoadingIconVisibility(false);
                }
            })
    }

    showQuizModel() {
        const { setQuizVisibility, closeMenu } = this.props;
        closeMenu();
        setQuizVisibility(true);
    }

    showWelcomeModel() {
        const { setShowWelcomeModal, closeMenu } = this.props;
        closeMenu();
        setShowWelcomeModal(1);
    }

    renderMenuItems = () => {
        const routeRendersRandom = linkedRandomScenes(this.props).map((scene, index) => (
            <React.Fragment key={scene.scene_id}>
                <CurrentStoreMenuGridItem
                    onHover={this.onHover}
                    onUnhover={this.onUnhover}
                    onClick={this.onClick}
                    scanData={scene}
                />
            </React.Fragment>
        ));
        return routeRendersRandom;
    };

    render() {
        return (<>
        <div className="selecter-menu-footer-text map-of-rooms" style={{cursor:"pointer"}} onClick={() => this.setState({ mapOpen: !this.state.mapOpen })}>

            <img className="menuImg" style={{height: "19px"}} src={mapImg}/>
            <p >{this.props.t('menuSection1')}</p>
            <img className="expand-arrow" src={this.state.mapOpen ? arrowExpanded : arrowUnexpanded}/>
        </div>

            <div className={`topRightNavigation ${this.state.mapOpen ? "" : "collapsed"}`}>
                <ul>
                    {this.renderMenuItems()}
                </ul>
            </div>
            <img src={menuLine} />
            <div className="selecter-menu-footer-section">

                <div className="selecter-menu-footer-text" style={{cursor:"pointer"}} onClick={() => {
                    QuizStoreSelectorClick();
                    this.showQuizModel();

                    }}>

                <img className="menuImg" src={giftImg}/><p >{this.props.t('menuSection3')}</p>
                </div>
                <img src={menuLine} />
                <div className="selecter-menu-footer-text" style={{cursor:"pointer"}} onClick={() => {
                    LegendStoreSelectorClick();
                    this.showWelcomeModel()
                }}>

                <img className="menuImg" src={legendImg}/><p >{this.props.t('menuSection2')}</p>
                </div>
            </div>
        </>);
    }
}

CurrentStoreMenuItemGrid.propTypes = {
    closeMenu: PropTypes.func,
    menuTextFontStyle: PropTypes.object,
    store: PropTypes.object,
    setLoadingIconVisibility: PropTypes.func,
    setQuizVisibility: PropTypes.func,
    setShowWelcomeModal: PropTypes.func
};

export default withTranslation()(props => (
    <AppContext.Consumer>
        {appContextValue => (
            <ThreeJSWorldContext.Consumer>
                {threeJSWorldContext => (
                    <I18NextContext.Consumer>
                        {i18Props => (
                            <CurrentStoreMenuItemGrid
                                {...props}
                                threeJSWorldContext={threeJSWorldContext}
                                setLoadingIconVisibility={appContextValue.setLoadingIconVisibility}
                                setQuizVisibility={appContextValue.setQuizVisibility}
                                setShowWelcomeModal={appContextValue.setShowWelcomeModal}
                                currentLanguage={i18Props.currentLanguage}
                            />
                        )}
                    </I18NextContext.Consumer>
                )}
            </ThreeJSWorldContext.Consumer>
        )}
    </AppContext.Consumer>
));
